import axios from "axios";
import { isLogged, removeToken, setLogged } from "@/utils/auth/user";
import cloneDeep from "lodash/cloneDeep";
import Message from "@/constants/config/Message";
import router from "@/router";
import StorageService from "./StorageService";
import ResponseStatusEnum from "@/constants/enum/ResponseStatusEnum";

const API_URL = process.env.VUE_APP_API_URL;

const apiService = axios.create({
  baseURL: API_URL,
});
let errorShow = true;

export const setupInterceptor = (Vue) => {
  apiService.interceptors.request.use(
    async (config) => {
      const newConfig = cloneDeep(config);
      const token = isLogged();
      if (token) {
        newConfig.headers.Authorization = `Bearer ${token}`;
        newConfig.headers.Accept = "application/json";
        newConfig.headers["Content-Type"] = "application/json";
      }
      return newConfig;
    },
    (error) => Promise.reject(error)
  );

  apiService.interceptors.response.use(
    (response) => {
      const { headers } = response;
      // If there is a refreshToken available in header
      const { refreshtoken } = headers;
      if (refreshtoken) {
        setLogged(refreshtoken);
      }
      if (
        response.data.status === ResponseStatusEnum.ERROR &&
        response.data.message === "Validation Error"
      ) {
        Object.keys(response.data.data).forEach((item) => {
          Vue.prototype.$toastr.error(response.data.data[item]?.message);
        });
        console.log("executed");
      }
      return response;
    },
    async (error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        switch (error.response.status) {
          case 400:
            if (errorShow === true) {
              Vue.prototype.$toastr.error(Message.ERROR_MESSAGE_400);
            }
            errorShow = false;
            break;
          case 401:
            if (errorShow === true) {
              Vue.prototype.$toastr.error(Message.ERROR_MESSAGE_401);
            }
            errorShow = false;
            StorageService.clear();
            removeToken();
            router.push({ name: "login" });
            break;
          case 403:
            // Once permission module is added, this needs to change to not
            // logout the user and just redirect to a safe place.
            Vue.prototype.$toastr.error(Message.ERROR_MESSAGE_403);
            StorageService.clear();
            removeToken();
            router.push({ name: "login" });
            break;
          case 404:
            Vue.prototype.$toastr.error(Message.ERROR_MESSAGE_404);
            break;
          case 410:
            Vue.prototype.$toastr.error(Message.ERROR_MESSAGE_410);
            StorageService.clear();
            removeToken();
            router.push({ name: "login" });
            break;
          case 500:
            Vue.prototype.$toastr.error(Message.ERROR_MESSAGE_500);
            break;
          default:
            Vue.prototype.$toastr.error(Message.ERROR_MESSAGE_0);
            break;
        }
      }
      return Promise.reject(error);
    }
  );
};

export default apiService;
